<template>
  <div id="app" class="container px-0">
    <div v-if="ready">

      <TradeList/>

      <VanList/>

    </div>

    <div v-else class="loading-screen row justify-content-center">
      <div class="col-2">
        <div class="loader">
          <span class="loader__progress">&nbsp;</span>
        </div>
      </div>
    </div>

    <Sprite class="off-screen"/>
  </div>
</template>

<script>
import TradeList from './components/TradeList.vue'
import VanList from './components/VanList.vue'
import 'slick-carousel/slick/slick.css';
import Sprite from '@/assets/img/sprite.defs.svg';

export default {
  name: 'app',
  components: {
    TradeList,
    VanList,
    Sprite
  },

  computed: {
    ready() {
      return this.$store.getters.getReady;
    },
  },

  created() {
    this.$store.commit("setReady", false);
    this.$store.dispatch('loadTrades');
  }
}
</script>

<style lang="stylus">
  #app
    padding-left 0
    padding-right 0
    margin-bottom 4rem

    .row
      margin-bottom 3rem

    .loader
      display flex
      position fixed
      z-index 100
      top 0
      left 0
      width 100vw
      height 100vh
      justify-content center
      align-items center
      background-color $color-white
      transition all .3s

      &__progress
        width 10rem
        height 10rem
        border 5px solid $color-blue-petrol
        border-left-color transparent
        border-radius 50%
        animation rotate 1.5s linear infinite

    .off-screen
      position absolute
      top -9999em
      ledt -9999em

    strong
      color $color-blue-petrol

    .slick-slider
      min-width 100%
      width 0

      .slick-list
        margin-right -3rem

        @media screen and (max-width: 767px)
          margin-right 0

      .slick-slide
        margin-right 3rem

        @media screen and (max-width: 767px)
          margin-right 0

    .paging
      display flex
      justify-content center
      align-items center

      .slick-arrow
        display block
        width 12px
        height 12px
        overflow hidden
        text-indent -999em
        border 0
        background-color transparent
        border-top 2px solid $color-blue-petrol
        border-right 2px solid $color-blue-petrol
        outline 0
        margin 0
        padding 0
        cursor pointer

        &.slick-disabled
          opacity .3

        &.slick-next
          order 3
          margin-left 1.5rem
          transform rotate(45deg)

        &.slick-prev
          margin-right 1.5rem
          transform rotate(-135deg)

      .slick-dots
        display flex
        list-style none
        justify-content center
        margin-top 3rem
        margin-bottom 3rem
        padding 0

        li
          &:not(:last-child)
            margin-right 2rem

        .slick-active
          button
            background-color $color-blue-bright
            border-color $color-blue-bright

        button
          display block
          overflow hidden
          text-indent -999em
          background-color transparent
          width 13px
          height 13px
          padding 0
          margin 0
          border 1px solid $color-blue-petrol
          border-radius 50%
          box-shadow none
          outline 0

    .fade-enter-active, .fade-leave-active
      transition opacity .3s

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
      opacity 0

@-webkit-keyframes rotate
  from
    -webkit-transform rotate(0deg)
  to
    -webkit-transform rotate(360deg)

</style>
